export const toKebabCase = (s: string): string =>
  s
    .replace(/['"?%$!./,()]/g, '')
    .replace(/\s/g, '-')
    .toLowerCase();

export const splitWordOnUpperCase = (s: string, separator = ' ') => s.match(/[A-Z][a-z]+|[0-9]+/g)?.join(separator);

/**
 * Reads the local file and converts it to a base64 string.
 */
export const toBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      const dataUrl = (event.target?.result as string) ?? '';
      resolve(dataUrl.substr(dataUrl.indexOf(',') + 1));
    };

    reader.readAsDataURL(file);
  });
};

/**
 * Converts a string to a base64 encoded string.
 * @param value The string to encode
 * @returns The base64 encoded string
 */
export const encodeStringToBase64 = (value: string): string => {
  return btoa(value);
};

export function isNullUndefinedOrWhitespace(str: string | null | undefined): boolean {
  return str === null || str === undefined || str.match(/^\s*$/) !== null;
}

export const toTitleCase = (target: string) =>
  target
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

/**
 * Extracts the path from a URL, removing query params and fragments
 * @param url The full URL string
 * @returns The URL path without query parameters or fragments
 */
export function getUrlPath(url: string): string {
  return url.split('?')[0].split('#')[0];
}

export function toStringOrEmpty(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}

/**
 * Prefixes a value with the provided string.
 */
export function prefixValue(value: unknown, prefix: string): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  return `${prefix}${String(value)}`;
}

/**
 * Splits a comma-separated string into trimmed, non-empty values.
 * @param value The string to split (e.g. `"GAS,WATER"`)
 * @returns Trimmed non-empty parts, or an empty array for null/undefined/blank input
 */
export function splitCommaSeparatedValues(value: string | null | undefined): string[] {
  if (!value?.trim()) {
    return [];
  }

  return value
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

/**
 * Splits a string by a separator and returns the specified part.
 * @param value The string to split
 * @param separator The separator to use
 * @param part The part to return
 * @returns The specified part of the string
 */
export function splitStringAndTakePart(value: string, separator: string, part: number): string {
  const parts = value.split(separator);
  return parts[part] ?? '';
}

/**
 * Returns everything after the final '/' character.
 * If '/' is not present, returns the original string.
 */
export function getFileNameFromPath(value: string): string {
  const idx = value.lastIndexOf('/');
  return idx >= 0 ? value.substring(idx + 1) : value;
}